<template>
  <b-modal
    id="modal-workplace-payroll-value"
    ref="workplacePayrollValueModal"
    :title="workplacePayrollValueMode.workplace_name ? `Editar Valor Folha (${workplacePayrollValueMode.workplace_name})` : ''"
    hide-footer
    centered
  >
    <div class="pb-2">
      <p class="mb-0">
        Valor Folha
      </p>
      <div class="-d-flex">
        <div class="w-100">
          <b-form
            @submit.prevent
          >
            <validation-provider
              #default="{ errors }"
              name="Limite"
              vid="payroll_value"
              rules="required"
            >
              <b-form-group
                label=""
                label-for="payroll_value"
                :class="errors.length > 0 ? 'is-invalid':null"
              >
                <cleave
                  id="payroll_value"
                  v-model="workplacePayrollValueMode.payroll_value"
                  name="payroll_value"
                  class="form-control"
                  :options="options.number"
                  :class="errors.length > 0 ? 'is-invalid':null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-form>
        </div>
        <div class="w-100 text-right">
          <b-button
            variant="primary"
            class="mt-3 -w-100"
            :disabled="loading"
            @click="editPayrollValue"
          >
            <span class="d-none d-sm-inline">Confirmar</span>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BModal, VBModal,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import useWorkplacePayrollValue from './useWorkplacePayrollValue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BModal,
    Cleave,
    ValidationProvider,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      options: {
        number: {
          numeralPositiveOnly: true,
          numericOnly: true,
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          prefix: 'R$ ',
          rawValueTrimPrefix: true,
        },
      },
    }
  },
  setup(_, { emit }) {
    const {
      loading,
      workplacePayrollValueModal,
      workplacePayrollValueMode,
      show,
      editPayrollValue,
    } = useWorkplacePayrollValue(() => emit('refetch-data'))

    return {
      loading,
      workplacePayrollValueModal,
      workplacePayrollValueMode,
      show,
      editPayrollValue,
    }
  },
}
</script>
